import React from 'react';
import DataTableRow from "../DataTableRow";
import DataTableCell from "../DataTableCell";

/**
 * DataTableEmptyState
 *
 * The table empty state component renders a single row with a single cell
 * that spans all columns with the text "No records found.".
 *
 * @param {Object[]} columns - The array of columns. Each column should
 * have an `id` property.
 * @returns {React.ReactNode} The rendered table body.
 */
const DataTableEmptyState = ({ columns }) => {
  return (
    <DataTableRow>
      <DataTableCell colSpan={columns.length} className="text-center">
        No records found.
      </DataTableCell>
    </DataTableRow>
  )
}

export default DataTableEmptyState
